import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Box, Typography, CardContent } from "@mui/material";
import Card from "@mui/material/Card";
import Arrow from "../../../../Assets/Svg/offersarrow.svg";
import { Styles } from "./styles";
import { showIconByServiceId } from "../../../../helpers/showIconByServiceId";

const TeamCard = ({ data }) => {
  const navigate = useNavigate();

  return (
      <Styles>
          <Box
              className="item-carosel"
              style={{padding : '0',width:'auto',minHeight:'300px'}}
              key={data.id}
              onClick={() => window.open(`/resellers/${data.id}`, "_blank")}
          >

              <div className="final-logo-container" style={{alignContent:'center',minHeight:'100px',margin:'0 20px',justifyItems:"center"}}>
                  <img
                      src={data.photo}
                      alt="panel"
                      style={{
                          border: "1px solid #296D99",
                          borderRadius: "50%",
                          cursor: "pointer",
                          width: "200px",
                          height: "200px",
                          maxWidth:200,
                          objectFit:'contain',
                      }}

                  />
                  <Typography
                      sx={{
                          fontSize: `23px`,
                          color: '#ffffff',
                      }}
                      className="final-logo"
                  >
                      {data.name}
                  </Typography>
              </div>

          </Box>
      </Styles>
  );
};

export default TeamCard;
